import { useGeo } from '../contexts/GeoContext';

/** Pays ISO alpha-2 pour autocomplétion / géocodage (indépendant de la langue UI). */
export function useGeoCountry(): string {
  return useGeo().geoCountry;
}
